import React from 'react';

export interface PriceCellProps {
  promotion?: any;
  game?: any;
  editable?: boolean;
}

function PriceCell({ promotion, game, editable }: PriceCellProps) {
  return (
    <div className={editable ? 'grid-price' : 'grid-price-readonly'}>£123</div>
  );
}

export default PriceCell;
